import { render, staticRenderFns } from "./HasilPostTest.vue?vue&type=template&id=10e1d4d6&"
import script from "./HasilPostTest.vue?vue&type=script&lang=js&"
export * from "./HasilPostTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports